import { Env } from '@/Env';
import EstateJurisdictionLang from '/@/modules/predefined/services/EstateJurisdictionLang';

export const Hubspot = {
  get FORM_SUBMIT_URL() {
    return 'https://api.hsforms.com/submissions/v3/integration/submit';
  },
  get MEETING_EMBED_CODE() {
    return 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
  },
  get SIGN_UP_FORM_ID() {
    return Env.nodeEnv().VITE_APP_HUBSPOT_SIGN_UP_FORM_ID;
  },
  get CE_WEBSITE_CONTACT_US_FORM_ID() {
    return Env.nodeEnv().VITE_APP_HUBSPOT_CE_WEBSITE_CONTACT_US_FORM_ID;
  },
  get PORTAL_ID() {
    return Env.nodeEnv().VITE_APP_HUBSPOT_PORTAL_ID;
  },
  get CONSULTATION_MEETING_LINK() {
    return Env.nodeEnv().VITE_APP_HUBSPOT_CONSULTATION_MEETING_LINK;
  },
  get HUBSPOT_DEAL_BASE_URL() {
    return Env.nodeEnv().VITE_APP_HUBSPOT_DEAL_BASE_URL;
  },
  get PROBATE_TAX_CALCULATOR_FORM_ID() {
    return Env.nodeEnv().VITE_APP_HUBSPOT_PROBATE_TAX_CALCULATOR_FORM_ID;
  },
  get PROBATE_MEETING_LINK() {
    return 'https://info.clearestate.com/book-a-free-consultation?utm_source=content&utm_medium=LP&utm_campaign=probate_calculator&utm_content=book_free_consult';
  },
  get AGENT_FOR_EXECUTOR_ADDENDUM_URL() {
    return 'https://f.hubspotusercontent20.net/hubfs/8693223/Platform-Facing/Agent%20for%20Executor%20Addendum_Jul.2021.pdf';
  },
  get GUIDANCE_MEETING_INSTRUCTIONS_URL() {
    return EstateJurisdictionLang.guidanceMeetingInstructionsUrl;
  }
};
